module.exports = __webpack_public_path__ + "static/media/layer_7.ccb45dd0.png";